import { Alert, Button, FormField } from "@prequel/shared-components";

import { FormState } from "../LoginCard";

import { useCheckSSOEnabled, usePasswordlessLogin } from "@/api/queries/auth";

type PasswordlessCardProps = {
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
};

const PasswordlessCard = ({ setFormState, email, setEmail }: PasswordlessCardProps) => {
  const passwordlessLogin = usePasswordlessLogin();
  const checkSSOEnabled = useCheckSSOEnabled();

  const onSendMeALink = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    passwordlessLogin.mutate(email, {
      onSuccess: () => {
        setFormState("PASSWORDLESS_SUBMITTED");
      },
    });
  };

  return (
    <form onSubmit={onSendMeALink} className="space-y-4">
      <FormField
        id="email"
        key="email"
        type="email"
        placeholder="you@yourcompany.com"
        value={email}
        label="Email"
        onChangeHandler={setEmail}
        required
        disabled
      />

      {checkSSOEnabled.isSuccess && checkSSOEnabled.data ? (
        <Alert>
          SSO is enabled.{" "}
          <span
            className="
              cursor-pointer font-semibold text-red-700
              hover:underline
            "
            onClick={() => setFormState("SSO_SELECTED")}
          >
            Sign in with SSO instead.
          </span>
        </Alert>
      ) : (
        <Button
          className="w-full"
          submit
          autoFocus
          disabled={passwordlessLogin.isPending}
          text={"Send me a one-time code"}
        />
      )}

      <div className="flex justify-center text-sm text-gray-500">
        <a
          className="
            cursor-pointer text-primary-600
            hover:underline
          "
          onClick={() => setFormState("NOTHING_SELECTED")}
        >
          Back to other options
        </a>
      </div>
    </form>
  );
};

export default PasswordlessCard;
